module.exports = __webpack_public_path__ + "static/media/news.992595b0.svg";